module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.983/img/blobsLeft.png"